var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',_vm._l((_vm.items),function(item){return _c('li',{key:item,staticClass:"my-1"},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":"primary"}},[_vm._v(" mdi-check-circle ")]),_c('span',{staticClass:"text-body-1"},[_vm._v(_vm._s(item))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }